<nz-skeleton [nzActive]="true" [nzLoading]="loading">
  <div
    nz-row
    *ngIf="
      (infoMatch.statusHalf.code === 1 || infoMatch.statusHalf.code === 8) &&
      infoMatch.competitionYouTube
    "
  >
    <div nz-col nzSpan="24">
      <nz-skeleton [nzActive]="true" [nzLoading]="loading">
        <div
          class="flex gap-5 max-sm:gap-3 bg-grey-5 rounded-5 px-5 py-4 cursor-pointer"
          (click)="goToLink(infoMatch.competitionYouTube)"
        >
          <div
            class="max-w-[146px] max-sm:max-w-[100px] w-full h-[146px] max-sm:h-[100px] bg-white rounded-full flex justify-center items-center"
          >
            <img
              alt="competitionLogo"
              class="max-w-[90px] h-[90px] max-sm:max-w-[60px] max-sm:h-[60px]"
              [src]="competitionLogo"
            />
          </div>
          <div class="flex flex-col font-roboto-600 py-3 leading-tight">
            <div class="text-24 max-sm:text-18">
              {{ "Highlights" | translate }}
            </div>
            <div class="text-20 max-sm:text-16">
              {{ competition }}
            </div>

            <img
              alt="youtube"
              class="max-w-[110px] w-full mt-auto"
              [src]="getYoutubeLogo()"
            />
          </div>
        </div>
      </nz-skeleton>
    </div>
  </div>

  <!-- <div class="flex justify-center" *ngIf="viewLiveTracker">
    <div class="my-2 container">
      <iframe
        class="iframe-livetracker"
        [src]="linkLiveTracker"
        name="myiFrame"
        scrolling="no"
        frameborder="0"
      >
      </iframe>
    </div>
  </div> -->

  <div class="flex justify-center" *ngIf="viewLiveTracker">
    <div class="my-2 container" #mainTracker>
      <iframe
        class="iframe-livetracker"
        [src]="linkLiveTracker"
        name="myiFrame"
        scrolling="no"
        frameborder="0"
      ></iframe>
    </div>
  </div>

  <!-- Floating Tracker -->
  <div class="floating-tracker" *ngIf="isTrackerHidden && viewLiveTracker">
    <iframe
      class="iframe-livetracker"
      [src]="linkLiveTracker"
      name="smallTracker"
      scrolling="no"
      frameborder="0"
    ></iframe>
  </div>

  <ng-container *ngIf="infoMatch.statusHalf.code != 1">
    <app-incidents
      [status]="infoMatch.statusHalf"
      [incidents]="incidentsFirstHalf"
      [title]="'FirstHalf'"
    >
    </app-incidents>
    <app-incidents
      [status]="infoMatch.statusHalf"
      [incidents]="incidentsSecondHalf"
      [title]="'SecondHalf'"
      *ngIf="incidentsSecondHalf.length > 0"
    >
    </app-incidents>
    <app-incidents
      [status]="infoMatch.statusHalf"
      [incidents]="incidentsOvertime"
      [title]="'Overtime'"
      *ngIf="incidentsOvertime.length > 0"
    >
    </app-incidents>
    <app-incidents
      [status]="infoMatch.statusHalf"
      [incidents]="incidentsPenaltys"
      [title]="'Penalty'"
      [isPenaltys]="true"
      *ngIf="incidentsPenaltys.length > 0"
    >
    </app-incidents>
  </ng-container>
</nz-skeleton>
